// banking/src/services/swap.service.ts
import { apiService } from './api.service';

// Interfaces para SWAP
export interface CreateSwapFiatToCryptoDto {
  fromAccountId: string;
  fromAmount: number;
  toWalletAddress: string;
  toCurrency: string;
}

export interface CreateSwapCryptoToFiatDto {
  fromWalletAddress: string;
  fromAmount: number;
  fromCurrency: string;
  toAccountId: string;
}

export interface SwapRequest {
  id: string;
  userId: string;
  ticketId: string;
  type: 'FIAT_TO_CRYPTO' | 'CRYPTO_TO_FIAT';
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';
  fromCurrency: string;
  fromAmount: number;
  fromAccountId?: string;
  fromWalletAddress?: string;
  toCurrency: string;
  toAmount?: number;
  toAccountId?: string;
  toWalletAddress?: string;
  commissionPercent?: number;
  commissionAmount?: number;
  netAmount?: number;
  txHash?: string;
  notes?: string;
  processedById?: string;
  processedAt?: Date;
  completedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  ticket?: any;
}

export interface SwapFilters {
  status?: string;
  limit?: number;
  offset?: number;
}

export interface SwapResponse {
  success: boolean;
  message?: string;
  data?: any;
  error?: {
    code: string;
    message: string;
  };
}

export const swapService = {
  /**
   * Crear solicitud FIAT → CRYPTO
   */
  createFiatToCrypto: async (dto: CreateSwapFiatToCryptoDto): Promise<SwapResponse> => {
    return await apiService.post<SwapResponse>('/swap/fiat-to-crypto', dto);
  },

  /**
   * Crear solicitud CRYPTO → FIAT
   */
  createCryptoToFiat: async (dto: CreateSwapCryptoToFiatDto): Promise<SwapResponse> => {
    return await apiService.post<SwapResponse>('/swap/crypto-to-fiat', dto);
  },

  /**
   * Obtener mis solicitudes de SWAP
   */
  getMyRequests: async (filters?: SwapFilters): Promise<SwapResponse> => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.offset) params.append('offset', filters.offset.toString());

    const queryString = params.toString();
    const endpoint = queryString ? `/swap/my-requests?${queryString}` : '/swap/my-requests';

    return await apiService.get<SwapResponse>(endpoint);
  },

  /**
   * Obtener detalle de una solicitud
   */
  getRequestById: async (requestId: string): Promise<SwapResponse> => {
    return await apiService.get<SwapResponse>(`/swap/my-requests/${requestId}`);
  },
};

export default swapService;
